import {Localized} from "@fluent/react";
import {Button} from "@mui/material";
import React, {useContext} from "react";

import SidebarContext, {SidebarType} from "../sidebars/SidebarContext";

function ReportIssueButton(props: {chapterExerciseKey?: string}) {
	const ctx = useContext(SidebarContext);

	function open() {
		ctx.open(SidebarType.ReportIssue, props.chapterExerciseKey);
	}

	return (
		<Button onClick={open}>
			<Localized id="report-issue-content-action">Report an issue</Localized>
		</Button>
	);
}

export default ReportIssueButton;
